import $ from 'jquery';

$(document).ready(()=>{
    $('.js-country').on('change',selectCountry);
})

function selectCountry(){

    var value = $(this).val();

    if(value == 0){
        return;
    }

    if(value.indexOf("http") !== -1){
        window.location = value;
    }else{
        window.location = '/' + value;
    }
}
